export default __webpack_public_path__ + "static/media/Klinikum_rechts_der_Isar_logo.02daaa26.svg";